
(function($) {
	
	"use strict";

	/*
		search
	*/
	if (!customElements.get('year-search')) {
		customElements.define('year-search', class YearSearch extends HTMLElement {
			constructor(){
				super()
				this.urlPath = ''
				this.year = document.querySelector('.select-year-parts')
				this.year.addEventListener('change', this.getMake.bind(this))
				this.makeDone = ''

				this.make = document.querySelector('.select-make-parts')
				this.make.addEventListener('change', this.getModel.bind(this))
				this.ModelDone = ''

				
				this.model = document.querySelector('.select-model-parts')
				this.model.addEventListener('change', this.getSubModel.bind(this))
				this.SubModelDone = ''

				this.submodel = document.querySelector('.select-sub-model-parts')
				this.submodel.addEventListener('change', this.getEng.bind(this))
				this.engineDone = ''
				
				this.engine = document.querySelector('.select-engine-parts')
				this.engine.addEventListener('change', this.finalEng.bind(this))
				this.engineFinal = ''
				this.formId = document.getElementById('the-forid')
				this.initYearSearch()
			} 
			getMake(evt){
				let selectVal = this.year.options[this.year.selectedIndex].value
				if( selectVal == 'select'){
					this.make.disabled = true
					this.model.disabled = true
					this.submodel.disabled = true
					this.engine.disabled = true
				}else{

					this.model.disabled = true
					this.submodel.disabled = true
					this.engine.disabled = true
					this.makeDone = selectVal
					this.urlPath = `/collections/all?filter.p.m.year_n.year_k=${selectVal}`
					this.formId.setAttribute("href", this.urlPath)
					axios.get(`/collections/all?filter.p.m.year_n.year_k=${selectVal}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const dataParce = parser.parseFromString(response.data, 'text/html')
							const dataParceTarget = dataParce.querySelector('.select-make-parts-result')

							let newMakeA = []
							for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
								if (dataParceTarget.options[i].value) newMakeA.push(dataParceTarget.options[i].value);
							}
							let uniqueArray = newMakeA.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var newMake = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueArray.forEach(
								option => {
									newMake += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.make.innerHTML = newMake
							this.make.disabled = false
						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})
				}
			}

			getModel(evt){
				
				let selectMake = this.make.options[this.make.selectedIndex].value
				if( selectMake == 'select'){
					this.model.disabled = true
					this.submodel.disabled = true
					this.engine.disabled = true
				}else{
					this.submodel.disabled = true
					this.engine.disabled = true
					this.ModelDone = selectMake
					this.urlPath = `/collections/all?filter.p.m.make_n.make_k=${selectMake}&filter.p.m.year_n.year_k=${this.makeDone}`
					this.formId.setAttribute("href", this.urlPath)
					axios.get(`/collections/all?filter.p.m.make_n.make_k=${selectMake}&filter.p.m.year_n.year_k=${this.makeDone}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const data = parser.parseFromString(response.data, 'text/html')
							const dataParceTarget = data.querySelector('.select-model-parts-result')
							
							let newModel = []
							for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
								if (dataParceTarget.options[i].value) newModel.push(dataParceTarget.options[i].value);
							}
							let uniqueArray = newModel.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var newModelRen = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueArray.forEach(
								option => {
									newModelRen += '<option value="' + option + '">' + option + '</option>';
								}
							)

							this.model.innerHTML = newModelRen
							this.model.disabled = false

						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})
				}
				
			}

			getSubModel(evt){
				let selectModel = this.model.options[this.model.selectedIndex].value

				if( selectModel == 'select'){
					this.submodel.disabled = true
					this.engine.disabled = true
				}else{
					this.SubModelDone = selectModel
					this.urlPath = `/collections/all?filter.p.m.make_n.make_k=${this.ModelDone}&filter.p.m.model_n.model_k=${selectModel}&filter.p.m.year_n.year_k=${this.makeDone}`
					this.formId.setAttribute("href", this.urlPath)
					axios.get(`/collections/all?filter.p.m.make_n.make_k=${this.ModelDone}&filter.p.m.model_n.model_k=${selectModel}&filter.p.m.year_n.year_k=${this.makeDone}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const data = parser.parseFromString(response.data, 'text/html')

							// class name
							const dataParceTarget = data.querySelector('.select-sub-model-parts-result')
							
							let subNewModel = []
							for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
								if (dataParceTarget.options[i].value) subNewModel.push(dataParceTarget.options[i].value);
							}
							let uniqueArray = subNewModel.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var subNewModelRe = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueArray.forEach(
								option => {
									subNewModelRe += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.submodel.innerHTML = subNewModelRe
							this.submodel.disabled = false

							// class name
							const dataEng = data.querySelector('.select-engine-parts-result')

							let newEng = []
							for (var i=0, n=dataEng.options.length; i<n; i++) {
								if (dataEng.options[i].value) newEng.push(dataEng.options[i].value);
							}
							let uniqueEng = newEng.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var uniqueEngSelect = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueEng.forEach(
								option => {
									uniqueEngSelect += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.engine.innerHTML = uniqueEngSelect
							this.engine.disabled = false

						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})
				}
			}

			getEng(evt){
				
				let selectEng = this.submodel.options[this.submodel.selectedIndex].value

				if( selectEng != 'select'){
					this.engineDone = selectEng
					this.urlPath = `/collections/all?filter.p.m.make_n.make_k=${this.ModelDone}&filter.p.m.model_n.model_k=${this.SubModelDone}&filter.p.m.sub_model_n.sub_model_k=${selectEng}&filter.p.m.year_n.year_k=${this.makeDone}`
					this.formId.setAttribute("href", this.urlPath)
					axios.get(`/collections/all?filter.p.m.make_n.make_k=${this.ModelDone}&filter.p.m.model_n.model_k=${this.SubModelDone}&filter.p.m.sub_model_n.sub_model_k=${selectEng}&filter.p.m.year_n.year_k=${this.makeDone}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const data = parser.parseFromString(response.data, 'text/html')
							const dataEng = data.querySelector('.select-engine-parts-result')


							let newEng= []
							for (var i=0, n=dataEng.options.length; i<n; i++) {
								if (dataEng.options[i].value) newEng.push(dataEng.options[i].value);
							}
							let uniqueEng = newEng.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var newEngS = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueEng.forEach(
								option => {
									newEngS += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.engine.innerHTML = newEngS
						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})
				}

				if( selectEng == 'select'){
					this.getSubModel()
				}
			}

			finalEng(evt){
				evt.preventDefault()
				let selectVal = this.engine.options[this.engine.selectedIndex].value
				if( selectVal != 'select'){
				}
			}

			initYearSearch(){
				axios.get(`/collections/all?view=ajax`)
				.then(
					response => {
						let parser = new DOMParser();
						const dataParce = parser.parseFromString(response.data, 'text/html')
						const dataParceTarget = dataParce.querySelector('.select-year-parts-result')
						let newYear = []

						for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
							if (dataParceTarget.options[i].value) newYear.push(dataParceTarget.options[i].value);
						}
						
						let uniqueArray = newYear.filter(function(item, pos, self) {
							return self.indexOf(item) == pos;
						})

						var newYearOp = '<option value="' + 'select' + '">' + 'select' + '</option>'
						uniqueArray.forEach(
							option => {
								newYearOp += '<option value="' + option + '">' + option + '</option>';
							}
						)
						this.year.innerHTML = newYearOp
						
					}
				)
				.catch(function (error) {
					console.log(error)
				})
				.finally(() => {
					// you finaly code here
				})
			}
		})
	}
	/*
		search
	*/
	if($('.search-icon-for-mobile').length){
		let searchIcon = document.querySelector('.search-icon-for-mobile')
		searchIcon.addEventListener('click', e => {
			document.body.classList.add("slide-search-open")
		})
	}

	if($('.brator-search-area-for-mobile-close').length){
		let searchIconC = document.querySelector('.brator-search-area-for-mobile-close')
		searchIconC.addEventListener('click', e => {
			document.body.classList.remove("slide-search-open")
		})
	
	}

	/*
		loadd popup newletter close
	*/
	
	document.addEventListener( 'DOMContentLoaded', function () {
		let popUpCloseO = document.querySelector('.popup-subdone-click')
		let popUpClose = document.querySelector('.brator-newsletter-pops-close')
		let popupFull = document.querySelector('.brator-news-letter-main-popup')


		let closePopupanyWay = localStorage.getItem('popup') ? localStorage.getItem('popup') : '' 

		if(closePopupanyWay == 'popup-dec' ){
			popupFull.style.display = 'none';
		} else{
			setTimeout(popupOpen, 5000)
		}

		function popupOpen(){
			popupFull.style.display = 'flex';
		}

		popUpClose.addEventListener('click', function(){
			localStorage.setItem('popup', 'popup-dec')
			popupFull.style.display = 'none';
		})
		popUpCloseO.addEventListener('click', function(){
			localStorage.setItem('popup', 'popup-dec')
			popupFull.style.display = 'none';
		})

		let urlPath = `${window.origin}/collections/`

		var tabProductAjax = document.querySelectorAll('.ajax-product-link button')
		if( tabProductAjax != null ){
			const tabNew = document.querySelector('#axi-product-tab')
			tabProductAjax.forEach(
				item => {
					let handler = item.dataset.handel
					item.addEventListener('click', e => {
						let updateUrlpath = urlPath + handler + '?view=coluct'

						tabNew.classList.add("loading-overlay")
						axios({
							method: "get",
							url: updateUrlpath
						})
						
						.then(
							response => {
								
								let parser = new DOMParser();
								const dataParce = parser.parseFromString(response.data, 'text/html')
								const dataParceTarget = dataParce.querySelector('#get_the_slider')
								
								tabNew.innerHTML = dataParceTarget.innerHTML

								let elms = document.getElementsByClassName( 'splide' );
								if(elms.length > 0 ){
									for ( let i = 0, len = elms.length; i < len; i++ ) {
										new Splide( elms[ i ] ).mount();
									}
								}
							}
						)
						.catch(function (error) {
							console.log(error)
						})
						.finally(() => {
							tabNew.classList.remove("loading-overlay")
							console.log('finally')
						})
					})
				}
			)
		}


		/*
			gsap start
		*/
	
		$('.brator-app-area').each(function(){

			var gsapTimeline = new TimelineMax();
			var controller = new ScrollMagic.Controller(
				{
					loglevel: 0
				}
			);
	

			var bgImg = $(this).find(".brator-app-content-area");
			 var tween2 = TweenMax.fromTo(
				bgImg,
				1,
				{
					css:{
						backgroundPosition:'45% -25px'
					},
					ease: Linear.easeNone
				},
				{
					css:{
						backgroundPosition:'55% -25px'
					},
					ease: Linear.easeNone
				}
			);
			gsapTimeline
					.add(tween2);
			var sectionBg = new ScrollMagic.Scene({
				tweenChanges: true,
				triggerElement: this,
				offset: 0,
				duration: "60%",
				triggerHook: 'onCenter', /// onEnter // onLeave
				loglevel: 2	
			})
			.addTo(controller)
			.setTween(
				gsapTimeline
			)
		});

		/*
			gsap end
		*/


		/*
			headre
		*/

		function headerStyle() {
			if($('.scroll-top').length){
				var windowpos = $(window).scrollTop();
				var scrollLink = $('.scroll-top');
				if (windowpos >= 270) {
					scrollLink.addClass('open');
				} else {
					scrollLink.removeClass('open');
				}
			}
		}


		/*
			scroll
		*/

		if($('.scroll-to-target').length){
			$(".scroll-to-target").on('click', function() {
				var target = $(this).attr('data-target');
			   // animate
			   $('html, body').animate({
				   scrollTop: $(target).offset().top
				 }, 1000);
		
			});
		}

		function scrollMenuStyle() {
			if($('.scroll-menu').length){
				var windowpos = $(window).scrollTop();
				var scrollLink = $('.scroll-menu');
				if (windowpos >= 270) {
					scrollLink.addClass('open');
					$('body').addClass('sticky-menu');
				} else {
					scrollLink.removeClass('open');
					$('body').removeClass('sticky-menu');
				}
			}
		}


		/*
			scroll end
		*/

		$(window).on('scroll', function() {
			headerStyle();
			scrollMenuStyle();
            PlaceMiniCart();
		});

		$(window).on('load', function() {
			handlePreloader();
		});
		/*
			splide start
		*/
	
		if($('.newsletter-form__message').length){
			setTimeout(function(){ 
				$('.newsletter-form__message').addClass('newsletter-form__message--success-hide');
			}, 3000);
		};

		
		let elms = document.getElementsByClassName( 'splide' );
		if(elms.length > 0 ){
			for ( let i = 0, len = elms.length; i < len; i++ ) {
				new Splide( elms[ i ] ).mount();
			}
		}
		
		document.addEventListener("shopify:section:load", e => {
			let elms = document.getElementsByClassName( 'splide' );
			if(elms.length > 0 ){
			  for ( let i = 0, len = elms.length; i < len; i++ ) {
				new Splide( elms[ i ] ).mount();
			  }
			}
		});
		

		  

		var productSliderPrice = document.getElementById('brator-rang-item-slider-nou');
		if( productSliderPrice != null ){
			noUiSlider.create(productSliderPrice, {
				start: [20, 80],
				connect: true,
				range: {
					'min': 0,
					'max': 100
				}
			});
		}
	let reviewSyncAuthore = document.getElementsByClassName( 'brator-client-review-author' );
	let reviewSyncReview = document.getElementsByClassName( 'brator-client-review' );

	if(reviewSyncAuthore.length > 0 ){
		// reviewSliderCount
		var reviewSlider = new Splide( '.brator-client-review', {
			type       : 'fade',
			cover      : true,
			rewind     : true,
			pagination : false
		} );
		
		var reviewSliderAuthor = new Splide( '.brator-client-review-author', {
			// rewind     : true,
			focus : 1,
			pagination : false,
			arrows : false,
			perPage : 3,
			perMove : 1,
			breakpoints : {
				1026: {
					perPage: 2
				},
				767: { 
					perPage: 1
				}
			}
			} );
		reviewSlider.sync(reviewSliderAuthor);
		reviewSlider.mount();
		reviewSliderAuthor.mount();
	}
	document.addEventListener("shopify:section:load", e => {
		let reviewSyncAuthore = document.getElementsByClassName( 'brator-client-review-author' );
		let reviewSyncReview = document.getElementsByClassName( 'brator-client-review' );

		if(reviewSyncAuthore.length > 0 ){
			// reviewSliderCount
			var reviewSlider = new Splide( '.brator-client-review', {
				type       : 'fade',
				cover      : true,
				rewind     : true,
				pagination : false
			} );
			
			var reviewSliderAuthor = new Splide( '.brator-client-review-author', {
				// rewind     : true,
				focus : 1,
				pagination : false,
				arrows : false,
				perPage : 3,
				perMove : 1,
				breakpoints : {
					1026: {
						perPage: 2
					},
					767: {
						perPage: 1
					}
				}
			  } );
			reviewSlider.sync(reviewSliderAuthor);
			reviewSlider.mount();
			reviewSliderAuthor.mount();
		}
	});
		/*
			splide end
		*/

		/*
			tab start
		*/
		document.body.classList.add("pp-type-grid")
		let gridList = document.querySelectorAll( '.brator-filter-view-type-link' );
		if(gridList.length > 0 ){
			gridList.forEach(
				(item, index) => {
					item.addEventListener('click', ()=>{
						gridList.forEach(
							(item, index) => {
								if(item.classList.contains("current")) item.classList.remove("current")
							}
						)
						item.classList.add("current")
						if(item.classList.contains("pp-type-grid")){
							document.getElementById('ProductGridContainer').classList.remove("type-list")
						}else{
							document.getElementById('ProductGridContainer').classList.add("type-list")
						}
					})
				}
			)
		}

		let productInfoImg = document.getElementsByClassName( 'brator-product-img-tab-list' );
		if(productInfoImg.length > 0 ){
			var tabProductImgItem = new Tabs({
				elem: "tabs-product-img",
				open: 0
			});	
			tabProductImgItem.open(0);
		}


		let productInfoTab = document.getElementsByClassName( 'brator-product-img-tab-list' );

		if(productInfoTab.length > 0 ){
			var tabProductItem = new Tabs({
				elem: "tabs-product-content",
				open: 0
			});
			tabProductItem.open(0);
		}


		if($('.brator-slide-menu-area .mega-menu-li').length){
			$('.brator-slide-menu-area .mega-menu-li > a').append('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/> </svg>')
		}

		if($('.brator-slide-menu-area .mega-menu-li').length){
			$('.brator-slide-menu-area .mega-menu-li a svg').on('click', function(e) {

				$(this).toggleClass('open');

				$(this).closest('.mega-menu-li').children('.mega-menu-area').slideToggle(500);

			})
		}


		if($('.brator-slide-menu-area .down-menu').length){
			$('.brator-slide-menu-area .down-menu-child > a').append('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/> </svg>')
		}

		if($('.brator-slide-menu-area .down-menu').length){
			$('.brator-slide-menu-area .down-menu a svg:not(.down-menu-child a svg)').on('click', function(e) {
				e.preventDefault()
				$(this).toggleClass('open');
				$(this).closest('.down-menu').children('ul').slideToggle(500);
			})
		}

		if($('.brator-slide-menu-area .down-menu .down-menu-child').length){
			$('.brator-slide-menu-area .down-menu:not(.down-menu a svg) .down-menu-child a svg').on('click', function(e) {
				$(this).toggleClass('open');
				$(this).closest('.n-menu-child').children('ul').slideToggle(500);
			})
		}
		
		/*
			tab end
		*/

	} );

	/*
		loading start
	*/

	function handlePreloader() {
        if ($('.loader-wrap').length) {
            $('.loader-wrap').hide()
        }
    }
 
    var pendingMiniCartError = null;

    function getCartDrawer() {
      return document.querySelector('.cart-drawerOuter');
    }

    function startLoader() {
      var drawer = getCartDrawer();
      if (!drawer) return;
      drawer.classList.add('is-loading');
      var spinEl = drawer.querySelector('.loading-overlay__spinner');
      if (!spinEl) {
        spinEl = document.createElement('div');
        spinEl.className = 'loading-overlay__spinner';
        spinEl.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
        drawer.appendChild(spinEl);
      }
      spinEl.classList.remove('hidden');
      spinEl.style.display = 'block';
    }

    function stopLoader() {
      var drawer = getCartDrawer();
      if (!drawer) return;
      drawer.classList.remove('is-loading');
      var spinners = drawer.querySelectorAll('.loading-overlay__spinner');
      for (var s = 0; s < spinners.length; s++) {
        spinners[s].classList.add('hidden');
        spinners[s].style.display = 'none';
      }
    }

    function cleanCartErrorMessage(message) {
      var cleanMessage = String(message || '').replace(/<[^>]*>/g, '').trim();
      return cleanMessage || 'Unable to update quantity.';
    }

    function findMiniCartLineByKey(key) {
      var $match = $();
      if (!key) return $match;
      var keyStr = String(key);
      var variantPart = keyStr.split(':')[0];
      $('.cart-drawerOuter .update-item').each(function() {
        var itemKey = $(this).attr('data-key') || '';
        if (itemKey === keyStr || itemKey.indexOf(variantPart + ':') === 0) {
          $match = $(this).closest('.brator-cart-item-list-item');
          return false;
        }
      });
      return $match;
    }

    function showMiniCartLineError(key, message) {
      var cleanMessage = cleanCartErrorMessage(message);
      var $line = findMiniCartLineByKey(key);
      if (!$line.length) $line = $('.cart-drawerOuter .brator-cart-item-list-item').first();
      if (!$line.length) return;

      var $error = $line.find('.cart-drawer-qty-error');
      if (!$error.length) {
        $error = $('<p class="cart-drawer-qty-error" role="alert"></p>');
        $line.find('.price-pdo').after($error);
      }
      $error.text(cleanMessage).removeAttr('hidden').css({ display: 'block', visibility: 'visible' });
    }

    function clearCartDrawerError() {
      $('.cart-drawerOuter .cart-drawer-qty-error, .cart-drawerOuter .cart-drawer-global-error')
        .text('')
        .attr('hidden', 'hidden')
        .hide();
    }

    function restoreMiniCartQty(thisEle, prevQty) {
      var $input = $(thisEle).closest('.update-item').find('[name="updates[]"]');
      if (!$input.length && $(thisEle).is('input')) $input = $(thisEle);
      if ($input.length) {
        $input.val(prevQty);
        $input.removeAttr('disabled');
        $input.removeData('qty-updating');
      }
      $(thisEle).removeAttr('disabled');
      $('.cart-drawerOuter [data-mini-cart] [data-minus-qtt], .cart-drawerOuter [data-mini-cart] [data-plus-qtt]').removeAttr('disabled');
    }

    function getCartQtyErrorMessage(availableQty, response) {
      if (typeof availableQty === 'number' && !isNaN(availableQty) && availableQty > 0) {
        var qtyErrorTpl = (window.cartStrings && window.cartStrings.quantityError) || 'You can only add [quantity] of this item to your cart.';
        return qtyErrorTpl.replace('[quantity]', availableQty);
      }
      if (response && response.description) return response.description;
      if (response && response.message && response.message !== 'Cart Error') return response.message;
      return (window.cartStrings && window.cartStrings.error) || 'Unable to update quantity.';
    }

    function getMiniCartMaxQty(thisEle) {
      var $wrap = $(thisEle).closest('.update-item');
      var $input = $wrap.find('[name="updates[]"]');
      var inventory = parseInt($wrap.attr('data-max-qty'), 10);
      // Use confirmed previous qty as floor — not a just-typed/incremented value.
      var prevQty = parseInt($input.data('prev-qty'), 10);
      if (isNaN(prevQty) || prevQty < 1) prevQty = parseInt($input.val(), 10) || 0;
      if (isNaN(inventory) || inventory < 0) return null;
      return Math.max(inventory, prevQty);
    }

    function extractAvailableQty(response) {
      if (!response) return null;
      var text = String(response.description || response.message || '');
      var match = text.match(/(\d+)/);
      if (!match) return null;
      var value = parseInt(match[1], 10);
      return (!isNaN(value) && value > 0) ? value : null;
    }

    function miniCartItems(){
      $.ajax({
        type: "GET",
        url: "/cart?view=cart-items",
        success: function(data) {
          var itemsHtml = $(data).find(".brator-cart-item-list-item-area-me").html();
          var totalPriceHtml = $(data).find(".brator-cart-total-money").html();
          if (itemsHtml && itemsHtml.indexOf('brator-cart-item-list-item') !== -1) {
            $('.cart-drawerOuter .brator-cart-item-list-item-area-me').html(itemsHtml);
            $('.cart-drawerOuter .brator-cart-total-money').removeClass('hide').html(totalPriceHtml);
          } else {
            $('.cart-drawerOuter .brator-cart-total-money').addClass('hide');
            $('.cart-drawerOuter .brator-cart-item-list-item-area-me').html('<div class="cartEmptyDiv">Your cart is currently empty.<a class="continueShopBtn">Continue Shopping</a></div>');
          }
          stopLoader();
          if (pendingMiniCartError) {
            var errorInfo = pendingMiniCartError;
            pendingMiniCartError = null;
            showMiniCartLineError(errorInfo.key, errorInfo.message);
          }
        },
        error: function() {
          stopLoader();
          if (pendingMiniCartError) {
            var errorInfo = pendingMiniCartError;
            pendingMiniCartError = null;
            showMiniCartLineError(errorInfo.key, errorInfo.message);
          }
        }
      });
    }

    function updateMiniCart(thisEle, id, qty, isRetry){
        var $line = $(thisEle).closest('.brator-cart-item-list-item');
        var $input = $line.find('[name="updates[]"]');
        var prevQty = parseInt($input.data('prev-qty'), 10);
        if (isNaN(prevQty) || prevQty < 1) {
          prevQty = parseInt($input.val(), 10);
          if (isNaN(prevQty) || prevQty < 1) prevQty = 1;
        }

        clearCartDrawerError();
        startLoader();

        var requestedQty = parseInt(qty, 10);
        if (isNaN(requestedQty)) requestedQty = prevQty;
        var maxQty = getMiniCartMaxQty(thisEle);
        var qtyNotice = null;
        var requestQty = requestedQty;

        // Cap to max available stock and show notice for the capped amount.
        if (!isRetry && maxQty !== null && requestQty > maxQty) {
          qtyNotice = getCartQtyErrorMessage(maxQty);
          if (maxQty === prevQty) {
            stopLoader();
            restoreMiniCartQty(thisEle, prevQty);
            showMiniCartLineError(id, qtyNotice);
            return;
          }
          requestQty = maxQty;
        }

        // Keep previous qty in the input while loading; refresh HTML shows the new value.
        $input.val(prevQty);

        $.ajax({
          type: "POST",
          url: '/cart/change.js',
          dataType: 'json',
          data: {
            id: id,
            quantity: requestQty
          },
          success: function(data) {
            if (data && (data.status === 422 || (!data.items && (data.description || data.message)))) {
              var availableFromError = extractAvailableQty(data);
              var retryQty = availableFromError || maxQty;
              var errMsg = qtyNotice || getCartQtyErrorMessage(retryQty, data);

              if (!isRetry && retryQty && retryQty > 0 && retryQty !== prevQty && requestedQty > retryQty) {
                pendingMiniCartError = { key: id, message: errMsg };
                $input.val(prevQty);
                updateMiniCart(thisEle, id, retryQty, true);
                return;
              }

              pendingMiniCartError = { key: id, message: errMsg };
              miniCartItems();
              return;
            }

            $('body').find('#cart-icon-bubble span').text(data.item_count);

            var matched = (data.items || []).find(function(item) { return item.key === id; });
            var finalKey = matched ? matched.key : id;
            var finalQty = matched ? matched.quantity : null;

            // Message must use the quantity actually available/set, not the old cart qty.
            if (qtyNotice) {
              pendingMiniCartError = { key: finalKey, message: getCartQtyErrorMessage(finalQty || requestQty) };
            } else if (requestedQty > 0 && finalQty !== null && finalQty < requestedQty) {
              pendingMiniCartError = { key: finalKey, message: getCartQtyErrorMessage(finalQty) };
            }

            miniCartItems();
          },
          error: function(xhr) {
            var response = {};
            try { response = JSON.parse(xhr.responseText); } catch (e) {}
            var availableFromError = extractAvailableQty(response);
            var retryQty = availableFromError || maxQty;
            var message = qtyNotice || getCartQtyErrorMessage(retryQty, response);

            if (!isRetry && retryQty && retryQty > 0 && retryQty !== prevQty && requestedQty > retryQty) {
              pendingMiniCartError = { key: id, message: message };
              $input.val(prevQty);
              updateMiniCart(thisEle, id, retryQty, true);
              return;
            }

            pendingMiniCartError = { key: id, message: message };
            miniCartItems();
          }
        });
    }

	if($('.brator-cart-link').length){
		$('.brator-cart-link #cart-icon-bubble, #cart-notification-button').on('click', function(e) {
          e.preventDefault();
          miniCartItems();
          $('.cart-drawerOuter').addClass('activeDrawer');
          $('body').addClass('drawerMode');
		});
	}

	$(document).on('click', '.brator-cart-close, .cart-drawer-overlay, .continueShopBtn', function(e) {
      e.preventDefault();
      $('.cart-drawerOuter').removeClass('activeDrawer');
      $('body').removeClass('drawerMode');
	});

	/*
		wl start
	*/
	
	if($('.wish-list-slide').length){
		$('.wish-list-slide').on('click', function(e) {
			$('body').toggleClass('mini-wish-open')
		})
	}

	if($('.wpl-dwar-close').length){
		$('.wpl-dwar-close').on('click', function(e) {
			$('body').toggleClass('mini-wish-open')
		})
	}

	/*
		wl end
	*/

	/*
		cmPa start
	*/
	
	if($('.compa-list-slide').length){
		$('.compa-list-slide').on('click', function(e) {
			$('body').toggleClass('mini-compa-open')
		})
	}

	if($('.compa-dwar-close-area').length){
		$('.compa-dwar-close-area').on('click', function(e) {
			$('body').toggleClass('mini-compa-open')
		})
	}

	
	// cookies start
		const handleDeclineSelector = document.getElementById('decline-btn-cok')
		const handleAcceptSelector = document.getElementById('accept-btn-cok')

		function getBannerEl() {
			return document.getElementById('cookies-banner');
		}
 
		function hideBanner(res) {
			getBannerEl().style.display = 'none';
		}

		function showBanner() {
		getBannerEl().style.display = 'block';
		}

		handleAcceptSelector.addEventListener('click', handleAccept)
		function handleAccept(e) {

			localStorage.setItem('kuki', 'kuki-acc')  
			window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);

			document.addEventListener('trackingConsentAccepted',function() {
			console.log('trackingConsentAccepted event fired');
			});
		}

		handleDeclineSelector.addEventListener('click', handleDecline)
		function handleDecline() {
			window.Shopify.customerPrivacy.setTrackingConsent(false,hideBanner);
		}

		function initCookieBanner() {
			const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
			const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

			if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
			showBanner();
			}
		}

		window.Shopify.loadFeatures([
			{
			name: 'consent-tracking-api',
			version: '0.1',
			}
		],
		function(error) {
			if (error) {
			throw error;
			}

			initCookieBanner();
		});

		// cookies end

	
	var getLogo = $('.brator-header-area .brator-logo').html();
	var getMenu = $('.brator-header-menu-area .brator-header-menu').html();
	
	if($('.brator-logo button').length){
		$('.brator-logo button').on('click', function() {
			$('body').addClass('mobile-menu-open');
		});

		$('.brator-slide-menu-bg').on('click', function() {
			$('body').removeClass('mobile-menu-open');
		});
		$('.brator-slide-menu-close').on('click', function() {
			$('body').removeClass('mobile-menu-open');
		});
 
		if($('.brator-slide-logo-items').length){
			$('.brator-slide-logo-items').append(getLogo);
		}
		if($('.brator-slide-menu-items').length){
			$('.brator-slide-menu-items').append(getMenu);
		}

	}

	/*
		menu end
	*/

	/*
		filtter start
	*/

	if($('.filter-enable').length){
		$('.filter-enable').on('click', function() {
			$('body').addClass('shop-filter-open');
		});
	}

	if($('.brator-sidebar-area.design-one .close-fillter').length){
		$('.brator-sidebar-area.design-one .close-fillter').on('click', function() {
			$('body').removeClass('shop-filter-open');
		});
	}


	/*
		filtter end
	*/

	/*
		mega menu  start
	*/


	$(".brator-header-menu li.mega-menu-li").click(function(){
		$(".brator-header-menu li").removeClass('active');
		$(this).addClass('active');
		$('body').addClass('brator-header-menu-bg');
		let docHeight = $(document).height() + 'px'
		$('.close-menu-bg').css("height", docHeight);
		
	});

	$(".close-menu-bg" ).click(function(){
		$(".brator-header-menu li").removeClass('active');
		$('body').removeClass('brator-header-menu-bg');
		let docHeight = 'auto'
		$('.close-menu-bg').css("height", docHeight);
	});

	$(".brator-mega-menu-close").click(function(){
		$(".brator-header-menu li").removeClass('active');
		$('body').removeClass('brator-header-menu-bg');
		let docHeight = 'auto'
		$('.close-menu-bg').css("height", docHeight); 
	});

	/*
		mega menu end
	*/

	/*
		filter  start
	*/

	if($('.brator-filter-item-area').length){
		$('.brator-filter-item-title').on("click", function(){
			if($(this).hasClass('current')){
				$(this).removeClass('current');
				let elHeight = $(this)[0].nextElementSibling.scrollHeight
				$(this).next().css("maxHeight", `${0}px`)
				$(this).next().css("height", `${0}px`)
			}else{
				$(this).addClass('current');
				let elHeight = $(this)[0].nextElementSibling.scrollHeight
				$(this).next().css("maxHeight", `${elHeight}px`)
				$(this).next().css("height", `${elHeight}px`)
			}
		});
	}
	
	if($('.rest-all-checkbox').length){
		$('.rest-all-checkbox').on("click", function(){
			$('.shop-sidebar-content input:checkbox').removeAttr('checked');
		});
	}

	if($('.sub-cat').length){
		$('.sub-cat').on("click", function(){
			
			if($(this).hasClass('current')){
				$(this).removeClass('current');
			}else{
				$(this).addClass('current');
			}
		});
	}


	/*
		filter end
	*/

	/*
		view more text  start
	*/

	if($('.brator-makes-list-view-more button').length){
		$('.brator-makes-list-view-more button').on("click", function(){
			if($('.brator-makes-list-single.disable').hasClass('current')){
				$('.brator-makes-list-single.disable').removeClass('current');
				$('.brator-makes-list-view-more button span b ').text('view more');
				$('.brator-makes-list-view-more button').removeClass('current');
			}else{
				$('.brator-makes-list-single.disable').addClass('current');
				$('.brator-makes-list-view-more button span b ').text('view less');
				$('.brator-makes-list-view-more button').addClass('current');
			}
		});
	}

	if($('.brator-more-text-view-more').length){
		$('.brator-more-text-view-more').on("click", function(){
			if($('.brator-more-text-view-more').hasClass('current')){
				$('.brator-more-text-view-more').removeClass('current');
				$('.brator-more-text-content .disable').removeClass('current');
				$('.brator-more-text-view-more button span').text('view more');
			}else{
				$('.brator-more-text-content .disable').addClass('current');
				$('.brator-more-text-view-more').addClass('current');
				$('.brator-more-text-view-more button span').text('view less');
			}
		});
	}


	/*
		view more text end
	*/

	let colorOpenTarget = document.querySelector('.svg-icon-picer')
	colorOpenTarget.addEventListener(
		'click', e => {
			colorOpenTarget.offsetParent.classList.toggle('open-plate')
		}
	)
	let colorList = document.querySelector('.color-area')
	let getButtonColor = colorList.querySelectorAll('button')
	getButtonColor.forEach(
		color => {
			let currentColor = color.dataset.color
			color.style.backgroundColor = currentColor
			color.addEventListener('mouseover', e=> {
				document.documentElement.style.setProperty('--color-one', currentColor)
				document.documentElement.style.setProperty('--color-two', currentColor)
			})
		}
	)
	/*
		input start
	*/


		
	let priceMin = $(".brator-rang-item-input-single input[name='filter.v.price.gte']").attr('value');
	if(priceMin != ''){
		$(".brator-rang-item-input-single input[name='filter.v.price.gte']").addClass('current')
	}
		
	let priceMax = $(".brator-rang-item-input-single input[name='filter.v.price.lte']").attr('value');
	if(priceMax != ''){
		$(".brator-rang-item-input-single input[name='filter.v.price.lte']").addClass('current')
	}

	$(".brator-rang-item-input-single input[name='filter.v.price.gte']").change( e => {
		let priceMinUpdate = e.target.value;
		if(priceMinUpdate != ''){
			$(".brator-rang-item-input-single input[name='filter.v.price.gte']").addClass('current-yaps')
		}else{
			$(".brator-rang-item-input-single input[name='filter.v.price.gte']").removeClass('current-yaps')
		}
	})

	$(".brator-rang-item-input-single input[name='filter.v.price.lte']").change( e => {
		let priceMaxUpdate = e.target.value;
		if(priceMaxUpdate != '') {
			$(".brator-rang-item-input-single input[name='filter.v.price.lte']").addClass('current-yaps')
		}else {
			$(".brator-rang-item-input-single input[name='filter.v.price.lte']").removeClass('current-yaps')
		}
	})

	/*
		input end
	*/

	/*
		coming soon start
	*/

	if($('.brator-coming-soon-counter').length){
		let dataTimer = $('.brator-coming-soon-counter').attr("data-options") 


		let {timer_year, timer_month, timer_day} = JSON.parse(dataTimer)
		

		// Set the date we're counting down to
		var countDownDate = new Date(`${timer_month} ${timer_day}, ${timer_year} 12:00:00`).getTime();
	
		// Update the count down every 1 second
		var x = setInterval(function() {
	
		// Get todays date and time
		var now = new Date().getTime();
	
		// Find the distance between now an the count down date
		var distance = countDownDate - now;
	
		// Time calculations for days, hours, minutes and seconds
		var days = Math.floor(distance / (1000 * 60 * 60 * 24));
		var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		var seconds = Math.floor((distance % (1000 * 60)) / 1000);
	
		// Display the result in the element with id="demo"
	
		document.getElementById("days").innerText = days
		document.getElementById("hours").innerText = hours
		document.getElementById("minutes").innerText = minutes
		document.getElementById("seconds").innerText = seconds
	
	
	
		// If the count down is finished, write some text 
			if (distance < 0) {
				clearInterval(x);
				document.getElementById("demo").innerHTML = "EXPIRED";
			}
		}, 1000);
	}

	let airStore = (JSON.parse(localStorage.getItem('compa'))) ? (JSON.parse(localStorage.getItem('compa'))) : []

	if(airStore.length == 0 ){
		document.body.classList.add('no-compare-product-link')
	}
	if(airStore.length > 0 ){  
		document.body.classList.remove('no-compare-product-link')
	}


	var compaDwar = document.querySelector('.compa-dwar ')
	compaDwar.innerHTML = ""
	airStore.forEach(
		(product, index) => {
			compaDwar.innerHTML += `<div class="brator-product-single-item-area splide__slide design-two"> <div class="brator-compare-product-content"> <div class="brator-product-single-item-info info-content-flex"> <div class="brator-product-single-item-info-right"><compa-list class="compa-incdec-area" data-api="${product.handle}"> <button id="btn-${product.handle}" class="compa-incdec active"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"></path> <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"></path> </svg></button> </compa-list></div> <div class="brator-product-single-item-info-left"> <div class="off-batch">20% OFF</div> </div> </div> <div class="brator-product-single-item-img"><a href="${product.url}"><img src="${product.featured_image}" alt="${product.title}"/></a></div> <div class="brator-product-single-item-mini"> <div class="brator-product-single-item-cat"><a href="product-layout-01.html">Brakepro</a></div> <div class="brator-product-single-item-title"> <h5><a href="${product.url}">${product.title}</a></h5> </div> <div class="brator-product-single-item-price"> <p><sub>$172.96</sub><b class="pub">$100</b></p> </div> </div> </div> <div class="brator-compare-product-info"> <div class="brator-compare-info-list"> <p>Short unique description</p> </div> <div class="brator-compare-info-list"> <p>Guess</p> </div> <div class="brator-compare-info-list"> <p>White</p> </div> <div class="brator-compare-info-list"> <p>Included Tax</p> </div> <div class="brator-compare-info-list"> <p>-</p> </div> </div> </div>`
		}
	)

	if($('.compa-dwar-action').length){
		$('.compa-dwar-action .product-compa-removed').click(function(){
			localStorage.removeItem('compa')
			document.querySelector('.compa-list-count').textContent = 0
			document.querySelector('.compa-dwar').innerHTML = ''
			document.body.classList.add('no-compare-product-link')
			document.querySelectorAll('.compa-incdec').forEach(
				(product, index) => {
					product.classList.remove('active')
				}
			)
		})
	}	



	let airStoreWi = (JSON.parse(localStorage.getItem('wPl'))) ? (JSON.parse(localStorage.getItem('wPl'))) : []
	if(airStoreWi.length == 0 ){
		document.body.classList.add('no-wish-product-link')
	}
	if(airStoreWi.length > 0 ){  
		document.body.classList.remove('no-wish-product-link')
	}

	var wplDwar = document.querySelector('.wpl-dwar')
	wplDwar.innerHTML = ""
	airStoreWi.forEach(
        (product, index) => {
          wplDwar.innerHTML += `<div class="brator-product-wpl-area"><div class="brator-product-single-item-img"> <a href="${product.url}"> <img src="${product.featured_image}" alt="${product.title}" loading="lazy" class="motion-reduce" width="925" height="617"> </a> </div> <div class="brator-product-single-item-mini"> <div class="brator-product-single-item-title"> <h5><a href="${product.url}"> ${product.title}</a></h5><wish-list class="wish-list" data-api="${product.handle}"> <button id="wish-${product.handle}" class="brator-wish-list-custom"> Remove </button> </wish-list></div> </div> </div>`
        }
	)

	if($('.wpl-dwar-action').length){
		$('.wpl-dwar-action .product-wish-removed-all').click(function(){
			localStorage.removeItem('wPl')
			document.querySelector('.wish-list-count').textContent = 0
			document.querySelector('.wpl-dwar').innerHTML = ''
			document.body.classList.add('no-wish-product-link')

			document.querySelectorAll('.brator-wish-list-custom').forEach(
				(product, index) => {
					product.classList.remove('active')
				}
			)

		})
	}
	
	/* 
		coming soon end
	*/

  /*custom code*/
  $(document).on('click', '#brator-icon-logged-user', function(){
      $(this).toggleClass('active');
      $('.menu-account-container').toggleClass('open');
  })

function PlaceMiniCart(){
  let checkLen = $('.sticky-menu #fixed-scroll-menu #cart-icon-bubble');
  if(checkLen.length){
    let checkPos = $('.sticky-menu #fixed-scroll-menu #cart-icon-bubble').offset();
    let topPos = checkPos.top;
    let leftPos = checkPos.left;
    let cartPopupWidth = $('.sticky-menu #regular-menu .brator-cart-item-list.mini-cart-open').width();
    leftPos = leftPos - cartPopupWidth;
  }
  else{
    // $('#regular-menu .brator-cart-item-list.mini-cart-open').css({"left":""});    
  }
}
  $(document).on('click', '#cart-icon-bubble', function(){
    PlaceMiniCart();
  })
  $(window).on('resize', function(){
    PlaceMiniCart();
  })
//mini cart
  $(document).on("click", "[data-mini-cart] [data-minus-qtt]", function() {    
    let thisEle = $(this);
    if (thisEle.is('[disabled]') || (getCartDrawer() && getCartDrawer().classList.contains('is-loading'))) return;
    thisEle.attr('disabled','disabled');
    let qtyInput = thisEle.closest('.update-item').find('[name="updates[]"]');
    let qty = parseInt(qtyInput.val(), 10) || 0;
    qtyInput.data('prev-qty', qty > 0 ? qty : 1);
    qty -= 1;
    startLoader(thisEle);
    let id = thisEle.closest('.update-item').attr('data-key');
    updateMiniCart(thisEle, id, qty);
    
  })
  $(document).on("click", "[data-mini-cart] [data-plus-qtt]", function() {
    let thisEle = $(this);
    if (thisEle.is('[disabled]') || (getCartDrawer() && getCartDrawer().classList.contains('is-loading'))) return;
    thisEle.attr('disabled','disabled');
    let qtyInput = thisEle.closest('.update-item').find('[name="updates[]"]');
    let qty = parseInt(qtyInput.val(), 10) || 0;
    qtyInput.data('prev-qty', qty > 0 ? qty : 1);
    qty += 1;
    startLoader(thisEle);
    let id = thisEle.closest('.update-item').attr('data-key');
    updateMiniCart(thisEle, id, qty);
  })
  $(document).on('mousedown', ".brator-cart-item-list-item [data-remove-item]", function(){
    $(this).closest('.brator-cart-item-list-item').find('input').data('is-removing', true);
  });

  $(document).on('click', ".brator-cart-item-list-item [data-remove-item]", function(event){
    event.preventDefault();
    let thisEle = $(this); 
    thisEle.attr('disabled','disabled');
    let $input = thisEle.closest('.brator-cart-item-list-item').find('[name="updates[]"]');
    let currentQty = parseInt($input.val(), 10);
    $input.data('prev-qty', (!isNaN(currentQty) && currentQty > 0) ? currentQty : 1);
    startLoader(thisEle);
    let qty = 0;
    let itemRow = thisEle.closest('.brator-cart-item-list-item');
    let id = itemRow.find('.update-item').attr('data-variant') || thisEle.attr('data-key') || itemRow.find('.update-item').attr('data-key'); 
    updateMiniCart(thisEle, id, qty);
  });

  $(document).on('focus', ".brator-cart-item-list-item input[name='updates[]']", function(){
    var currentQty = parseInt($(this).val(), 10);
    $(this).data('prev-qty', (!isNaN(currentQty) && currentQty > 0) ? currentQty : 1);
  });

  $(document).on('keydown', ".brator-cart-item-list-item input[name='updates[]']", function(e){
    if (e.key === 'Enter') {
      e.preventDefault();
      $(this).trigger('change').blur();
    }
  });

  $(document).on('change', ".brator-cart-item-list-item input[name='updates[]']", function(){
    var thisEle = $(this);
    if (thisEle.data('qty-updating')) return;

    var raw = $.trim(thisEle.val());
    var prevQty = parseInt(thisEle.data('prev-qty'), 10);
    if (isNaN(prevQty) || prevQty < 1) prevQty = 1;

    // Empty field: restore previous quantity, do not update cart.
    if (raw === '') {
      thisEle.val(prevQty);
      return;
    }

    var qty = parseInt(raw, 10);
    if (isNaN(qty) || qty < 0) {
      thisEle.val(prevQty);
      return;
    }

    // Normalize typed value but keep showing previous qty until load finishes.
    if (qty === prevQty) {
      thisEle.val(prevQty);
      return;
    }

    thisEle.val(prevQty);
    thisEle.data('qty-updating', true);
    thisEle.attr('disabled','disabled');
    startLoader(thisEle);
    var id = thisEle.closest('.update-item').attr('data-key');
    updateMiniCart(thisEle, id, qty);
  });

  
//cart page — same qty rules as cart drawer
  var pendingCartPageError = null;

  function startCartPageLoader() {
    $('.brator-cart-area .brator-cart-item-list-overlay').addClass('open');
  }

  function stopCartPageLoader() {
    $('.brator-cart-area .brator-cart-item-list-overlay').removeClass('open');
  }

  function getCartPageQtyInput(thisEle) {
    var $input = $(thisEle).closest('.update-item').find('[data-quantity-input], [name="updates[]"]');
    if (!$input.length && $(thisEle).is('input')) $input = $(thisEle);
    return $input;
  }

  function getCartPageMaxQty(thisEle) {
    var $wrap = $(thisEle).closest('.update-item');
    var $input = getCartPageQtyInput(thisEle);
    var inventory = parseInt($wrap.attr('data-max-qty'), 10);
    var prevQty = parseInt($input.data('prev-qty'), 10);
    if (isNaN(prevQty) || prevQty < 1) prevQty = parseInt($input.val(), 10) || 0;
    if (isNaN(inventory) || inventory < 0) return null;
    return Math.max(inventory, prevQty);
  }

  // Desk + mobile each have a qty input — keep them in sync.
  function setCartPageLineQty(thisEle, qty) {
    var $line = $(thisEle).closest('.brator-cart-list-items');
    var $inputs = $line.length
      ? $line.find('[data-quantity-input], input[name="updates[]"]')
      : getCartPageQtyInput(thisEle);
    $inputs.val(qty);
  }

  function restoreCartPageQty(thisEle, prevQty) {
    setCartPageLineQty(thisEle, prevQty);
    var $line = $(thisEle).closest('.brator-cart-list-items');
    var $inputs = $line.length
      ? $line.find('[data-quantity-input], input[name="updates[]"]')
      : getCartPageQtyInput(thisEle);
    $inputs.removeAttr('disabled').removeData('qty-updating');
    $(thisEle).removeAttr('disabled');
    $('[data-page-cart] [data-minus-qtt], [data-page-cart] [data-plus-qtt]').removeAttr('disabled');
  }

  function findCartPageLineByKey(key) {
    var $match = $();
    if (!key) return $match;
    var keyStr = String(key);
    var variantPart = keyStr.split(':')[0];
    $('#main-cart-items .update-item').each(function() {
      var itemKey = $(this).attr('data-key') || '';
      if (itemKey === keyStr || itemKey.indexOf(variantPart + ':') === 0) {
        $match = $(this).closest('.brator-cart-list-items');
        return false;
      }
    });
    return $match;
  }

  function showCartPageLineError(key, message) {
    var cleanMessage = cleanCartErrorMessage(message);
    var $line = findCartPageLineByKey(key);
    if (!$line.length) $line = $('#main-cart-items .brator-cart-list-items').first();
    if (!$line.length) return;

    var $errors = $line.find('.cart-page-qty-error');
    if (!$errors.length) {
      $line.find('.brator-cart-list-items-qty').each(function() {
        $(this).append('<p class="cart-page-qty-error" role="alert"></p>');
      });
      $errors = $line.find('.cart-page-qty-error');
    }
    $errors.text(cleanMessage).removeAttr('hidden').css({ display: 'block', visibility: 'visible' });
  }

  function clearCartPageErrors() {
    $('.template--cart .cart-page-qty-error').text('').attr('hidden', 'hidden').hide();
  }

  function refreshCartPage(callback) {
    $.ajax({
      type: 'get',
      url: '/cart?view=ccupdatelq',
      dataType: 'html',
      success: function(t) {
        var cartItems = $(t).find('#main-cart-items').html();
        var cartTotal = $(t).find('#main-cart-items').attr('data-cart-total');
        $('#main-cart-items').html(cartItems);
        reinitCartSubscriptionWidgets();
        if (cartTotal) $('.totals__subtotal-value').html(cartTotal);
        stopCartPageLoader();
        if (pendingCartPageError) {
          var errorInfo = pendingCartPageError;
          pendingCartPageError = null;
          showCartPageLineError(errorInfo.key, errorInfo.message);
        }
        if (typeof callback === 'function') callback();
      },
      error: function() {
        stopCartPageLoader();
        if (pendingCartPageError) {
          var errorInfo = pendingCartPageError;
          pendingCartPageError = null;
          showCartPageLineError(errorInfo.key, errorInfo.message);
        }
      }
    });
  }

  $(document).on('click', '[data-page-cart] [data-minus-qtt]', function(){
    var thisEle = $(this);
    if (thisEle.is('[disabled]') || $('.brator-cart-area .brator-cart-item-list-overlay').hasClass('open')) return;
    thisEle.attr('disabled', 'disabled');
    var $line = thisEle.closest('.brator-cart-list-items');
    var qtyInput = getCartPageQtyInput(thisEle);
    var qty = parseInt(qtyInput.val(), 10) || 0;
    var prev = qty > 0 ? qty : 1;
    $line.find('[data-quantity-input], input[name="updates[]"]').data('prev-qty', prev);
    qtyInput.data('prev-qty', prev);
    qty -= 1;
    var id = thisEle.closest('.update-item').attr('data-key');
    updateCart(thisEle, id, qty);
  });

  $(document).on('click', '[data-page-cart] [data-plus-qtt]', function(){
    var thisEle = $(this);
    if (thisEle.is('[disabled]') || $('.brator-cart-area .brator-cart-item-list-overlay').hasClass('open')) return;
    thisEle.attr('disabled', 'disabled');
    var $line = thisEle.closest('.brator-cart-list-items');
    var qtyInput = getCartPageQtyInput(thisEle);
    var qty = parseInt(qtyInput.val(), 10) || 0;
    var prev = qty > 0 ? qty : 1;
    $line.find('[data-quantity-input], input[name="updates[]"]').data('prev-qty', prev);
    qtyInput.data('prev-qty', prev);
    qty += 1;
    var id = thisEle.closest('.update-item').attr('data-key');
    updateCart(thisEle, id, qty);
  });

  $(document).on('focus', '[data-page-cart] [data-quantity-input]', function(){
    var currentQty = parseInt($(this).val(), 10);
    $(this).data('prev-qty', (!isNaN(currentQty) && currentQty > 0) ? currentQty : 1);
  });

  $(document).on('keydown', '[data-page-cart] [data-quantity-input]', function(e){
    if (e.key === 'Enter') {
      e.preventDefault();
      $(this).trigger('change').blur();
    }
  });

  $(document).on('change', '[data-page-cart] [data-quantity-input]', function(){
    var thisEle = $(this);
    if (thisEle.data('qty-updating')) return;

    var raw = $.trim(thisEle.val());
    var prevQty = parseInt(thisEle.data('prev-qty'), 10);
    if (isNaN(prevQty) || prevQty < 1) prevQty = 1;

    // Empty field: restore previous quantity, do not update cart.
    if (raw === '') {
      thisEle.val(prevQty);
      return;
    }

    var qty = parseInt(raw, 10);
    if (isNaN(qty) || qty < 0) {
      thisEle.val(prevQty);
      return;
    }

    if (qty === prevQty) {
      setCartPageLineQty(thisEle, prevQty);
      return;
    }

    thisEle.data('qty-updating', true);
    thisEle.attr('disabled', 'disabled');
    var id = thisEle.closest('.update-item').attr('data-key');
    updateCart(thisEle, id, qty);
  });

  $(document).on('click', '.template--cart [data-remove-item]', function(event) {
    event.preventDefault();
    var thisEle = $(this);
    thisEle.attr('disabled', 'disabled');
    var $line = thisEle.closest('.brator-cart-list-items');
    var $input = $line.find('[data-quantity-input], [name="updates[]"]').first();
    var currentQty = parseInt($input.val(), 10);
    $line.find('[data-quantity-input], [name="updates[]"]').data('prev-qty', (!isNaN(currentQty) && currentQty > 0) ? currentQty : 1);
    var id = $line.attr('data-key') || thisEle.closest('[data-key]').attr('data-key');
    updateCart(thisEle, id, 0);
  });

  function reinitCartSubscriptionWidgets() {
    try {
      if (typeof window.appstleInit === 'function') {
        window.appstleInit();
      } else if (typeof appstleInit === 'function') {
        appstleInit();
      }
    } catch (e) {}
  }

  //update cart (aligned with drawer: empty restore, 0 remove, clamp max, line error)
  function updateCart(thisEle, id, qty, isRetry){
    var $input = getCartPageQtyInput(thisEle);
    var prevQty = parseInt($input.data('prev-qty'), 10);
    if (isNaN(prevQty) || prevQty < 1) {
      prevQty = parseInt($input.val(), 10);
      if (isNaN(prevQty) || prevQty < 1) prevQty = 1;
    }

    clearCartPageErrors();
    startCartPageLoader();

    var requestedQty = parseInt(qty, 10);
    if (isNaN(requestedQty)) requestedQty = prevQty;
    var maxQty = getCartPageMaxQty(thisEle);
    var qtyNotice = null;
    var requestQty = requestedQty;

    if (!isRetry && maxQty !== null && requestQty > maxQty) {
      qtyNotice = getCartQtyErrorMessage(maxQty);
      if (maxQty === prevQty) {
        stopCartPageLoader();
        restoreCartPageQty(thisEle, prevQty);
        showCartPageLineError(id, qtyNotice);
        return;
      }
      requestQty = maxQty;
    }

    // Keep previous qty visible while loading; refreshed markup shows the new value.
    setCartPageLineQty(thisEle, prevQty);

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: id,
        quantity: requestQty
      },
      success: function(data) {
        if (data && (data.status === 422 || (!data.items && (data.description || data.message)))) {
          var availableFromError = extractAvailableQty(data);
          var retryQty = availableFromError || maxQty;
          var errMsg = qtyNotice || getCartQtyErrorMessage(retryQty, data);

          if (!isRetry && retryQty && retryQty > 0 && retryQty !== prevQty && requestedQty > retryQty) {
            pendingCartPageError = { key: id, message: errMsg };
            setCartPageLineQty(thisEle, prevQty);
            updateCart(thisEle, id, retryQty, true);
            return;
          }

          pendingCartPageError = { key: id, message: errMsg };
          refreshCartPage();
          return;
        }

        var discountApp = data.cart_level_discount_applications;
        if (discountApp && discountApp.length) {
          discountApp.forEach(function(item) {
            $('.normalCartDiscount').remove();
            $('.ajaxDiscount').removeClass('hide');
            $('.ajaxDiscount label').text(item['discount_application'].title);
            $('.ajaxDiscount span').text(Shopify.formatMoney(item['discount_application'].total_allocated_amount));
          });
        } else {
          $('.ajaxDiscount').addClass('hide');
          $('.normalCartDiscount').remove();
        }

        $('.brator-cart-icon.click-item-count').find('.count').text(data.item_count);
        $('#cart-icon-bubble span').text(data.item_count);
        if (data.item_count === 0) {
          $('cart-items.cart-item-list').addClass('is-empty');
          $('.cart-total-area-outer').hide();
          $('.cart__warningsOuter').removeClass('col-xl-8 col-lg-7 col-sm-7');
        }

        var matched = (data.items || []).find(function(item) { return item.key === id; });
        var finalKey = matched ? matched.key : id;
        var finalQty = matched ? matched.quantity : null;

        if (qtyNotice) {
          pendingCartPageError = { key: finalKey, message: getCartQtyErrorMessage(finalQty || requestQty) };
        } else if (requestedQty > 0 && finalQty !== null && finalQty < requestedQty) {
          pendingCartPageError = { key: finalKey, message: getCartQtyErrorMessage(finalQty) };
        }

        refreshCartPage();
      },
      error: function(xhr) {
        var response = {};
        try { response = JSON.parse(xhr.responseText); } catch (e) {}
        var availableFromError = extractAvailableQty(response);
        var retryQty = availableFromError || maxQty;
        var message = qtyNotice || getCartQtyErrorMessage(retryQty, response);

        if (!isRetry && retryQty && retryQty > 0 && retryQty !== prevQty && requestedQty > retryQty) {
          pendingCartPageError = { key: id, message: message };
          setCartPageLineQty(thisEle, prevQty);
          updateCart(thisEle, id, retryQty, true);
          return;
        }

        pendingCartPageError = { key: id, message: message };
        refreshCartPage();
      }
    });
  }

  //pdp
  $(document).on('click', '.show-more-oem', function(){
    $(this).toggleClass('active');
    $('.more-oem').slideToggle();
    if($(this).hasClass('active')){
      $(this).text('Show Less');
    }
    else{      
      $(this).text('Show More');
    }
  })

  //buy-now-btn
  $(document).on('click', '.buy-now-btn', function(){
    console.log('click');
    let id = $('[name="id"]').val();
    let qty = $('[name="quantity"]').val();
    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      dataType: 'json',
      data:{
        id: id,
        quantity:qty
      },
      success: function(data) {
        setTimeout(function(){
          window.location.href = "/cart";
        },500)
      }
    });
  })

    //toggle password
  $(document).on('click', '.toggle-password', function(){
    $(this).closest('.field').find('input[type="password"]').attr('type','text');
    $(this).text('Hide Password').addClass('hide-class');
  })
  $(document).on('click', '.toggle-password.hide-class', function(){
    $(this).closest('.field').find('input[type="text"]').attr('type','password');
    $(this).text('Show Password').removeClass('hide-class');
  });

  if($('body').hasClass('template-contact') && window.location.search=='?contact_posted=true'){
    var target = $('#ContactForm');
			   // animate
     $('html, body').animate({
         scrollTop: $(target).offset().top - 100
       }, 1000);
  }

  
  
})(window.jQuery);	
// document.addEventListener( 'DOMContentLoaded', function () {
//   new Splide('#splide01', {
//     type: 'loop',
//     autoplay: true,
//     interval: 3000,
//     updateOnMove: true,
//     throttle: 300
    
//   }).mount();  
// });
